import styled, { css } from 'styled-components'

import { theme } from '@/styles/theme'

const StyledLink = css`
  color: ${theme.colors.trialBlue};
  text-decoration: underline;
`
export const SummaryDiv = styled.div<{ color?: string }>`
  text-align: left;
  font-size: 16px;
  color: ${({ color }) =>
    color === undefined ? theme.colors.textTitle : color};
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.32px;

  a {
    ${StyledLink}
  }

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 25px;
    letter-spacing: 0.3px;
  }
`
const H3Style = css`
  font-size: 22px;
  color: ${theme.colors.trialBlue};
  font-weight: bold;
  line-height: 30px;
  letter-spacing: 0.88px;

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    letter-spacing: 0.6px;
  }
`

export const StyledH3 = styled.h3`
  ${H3Style}
`

export const SectionDiv = styled.div<{ color?: string; liWidth?: string }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  text-align: left;
  font-size: 16px;
  color: ${({ color }) =>
    color === undefined ? theme.colors.textTitle : color};
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.32px;

  h3 {
    ${H3Style}
  }

  ul {
    li {
      max-width: ${({ liWidth }) =>
        liWidth === undefined ? '100%' : `${liWidth}px`};
    }
  }

  ol {
    padding-left: 25px;
    list-style-type: decimal;
  }

  li {
    span {
      display: block;
      font-weight: bold;
    }
  }

  p {
    span {
      font-weight: bold;
    }
  }

  a {
    ${StyledLink}
  }

  @media screen and (max-width: 1047px) {
    row-gap: 30px;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.28px;

    ul {
      li {
        width: 100%;
      }
    }
  }
`

export const GridTable = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-template-rows: auto;
  border-top: 1px solid #707070;
  border-left: 1px solid #707070;

  @media screen and (max-width: 1047px) {
    grid-template-columns: 50% 50%;
  }
`

// カラムが６つのテーブル、テーブル内の文章が単語関係なく改行
export const GridTable2 = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 16.6666667%);
  grid-template-rows: auto;
  border-top: 1px solid #707070;
  border-left: 1px solid #707070;
  word-break: break-all;

  // @media screen and (min-width: 1048px) {
  //   overflow-x: auto; /* スクロール可能にする */
  //   max-width: 1048px; /* テーブルの幅を固定 */
  // }
`

export const GridRow = styled.div`
  width: 100%;
  display: contents;
  border-bottom: 1px solid #707070;

  div {
    border-bottom: 1px solid #707070;
    border-right: 1px solid #707070;
    padding: 20px 20px;
  }

  @media screen and (max-width: 1047px) {
    margin: 0px 20px;

    div {
      padding: 16px 20px 18px;
    }
  }
`

export const StyledList = styled.ul<{
  startValue?: number
  liWidth?: string
  marginLeft?: string
  paddingLeft?: string
}>`
  counter-reset: number
    ${({ startValue }) => (startValue === undefined ? '' : startValue)};
  max-width: ${({ liWidth }) =>
    liWidth === undefined ? '100%' : `${liWidth}px`};
  margin-left: ${({ marginLeft }) =>
    marginLeft === undefined ? '0' : `${marginLeft}em`};

  @media screen and (max-width: 1047px) {
    width: 100%;
    margin-left: 0;
    padding-left: ${({ paddingLeft }) =>
      paddingLeft === undefined ? '0' : `${paddingLeft}em`};
  }
`

export const StyledListInGridRow = styled(StyledList)`
  padding-left: 0.8em;
`

const Article = css`
  padding-left: 1.5em;
  text-indent: -2.5em;

  ::before {
    counter-increment: number;
    content: '（' counter(number) '）';
  }
`

const BoldArticle = css`
  padding-left: 1.5em;
  text-indent: -2.5em;
  font-weight: bold;

  p {
    text-indent: 0em;
    font-weight: 400;
  }

  ::before {
    counter-increment: number;
    content: '（' counter(number) '）';
  }
`

const Disc = css`
  text-indent: -1em;

  ::before {
    counter-increment: number;
    content: '・';
  }
`

const Comment = css`
  padding-left: 0.5em;
  text-indent: -3.5em;

  ::before {
    counter-increment: number;
    content: '（注' counter(number) '）';
  }

  @media screen and (max-width: 1047px) {
    text-indent: -0.5em;
  }
`
const Number = css`
  padding-left: 0.5em;
  text-indent: -1.5em;

  ::before {
    counter-increment: number;
    content: counter(number) '. ';
  }
`

export const StyledListItem = styled.li<{
  listType?: 'article' | 'disc' | 'comment' | 'boldArticle' | 'number'
  paddingLeft?: string
  textIndent?: string
}>`
  font-weight: 400;

  ${({ listType }) => {
    switch (listType) {
      case 'article':
        return Article
      case 'disc':
        return Disc
      case 'comment':
        return Comment
      case 'boldArticle':
        return BoldArticle
      case 'number':
        return Number
      case undefined:
        break
    }
  }}

  ${({ paddingLeft }) => paddingLeft && `padding-left:${paddingLeft}em`};
  ${({ textIndent }) => textIndent && `text-indent:${textIndent}em`};
`
export const ZenkakuSpace = styled.span<{ space?: string }>`
  padding-left: ${({ space }) => (space === undefined ? '1em' : `${space}em`)};
`
